import React from 'react';
import { useFilters } from '../hooks/use-filters';
import { DateSelector } from './date-selector';

export const StartDateSelector = () => {
    const {
        startDate,
        setStartDate
    } = useFilters();
    return (
        <DateSelector
            placeholder='Start Date'
            value={startDate}
            onChange={setStartDate}
        />
    );
};
